import { AxiosResponse } from "axios";

import { $axios } from "@/shared/api";
import {
  IProcessVoiceConversationParams,
  IStartVoiceConversationParams,
  IStartVoiceConversationResponse,
  IStopVoiceConversationParams,
  IStopVoiceConversationResponse,
  IVoiceConversationStatusParams,
  IVoiceConversationStatusResponse,
} from "../model/types";

class VoiceChatService {
  async startVoiceConversation(params: IStartVoiceConversationParams) {
    const response = await $axios.post<
      IStartVoiceConversationParams,
      AxiosResponse<IStartVoiceConversationResponse>
    >("/StartVoiceConversation", params);
    return response.data;
  }

  async processVoiceConversation({
    abortController,
    conversation_id,
    audio,
  }: IProcessVoiceConversationParams) {
    const formData = new FormData();

    formData.append("conversation_id", conversation_id);
    formData.append("audio", audio);

    const response = await $axios.post<
      Pick<IProcessVoiceConversationParams, "conversation_id" | "audio">,
      AxiosResponse<Blob>
    >("/ProcessVoiceConversation", formData, {
      responseType: "blob",
      signal: abortController.signal,
    });

    const conversationId = response.headers["x-conversation-id"] as string;
    const conversationStatus = response.headers[
      "x-conversation-status"
    ] as string;

    return {
      audio: response.data,
      conversationId,
      conversationStatus,
    };
  }

  async stopVoiceConversation(params: IStopVoiceConversationParams) {
    const response = await $axios.post<
      IStopVoiceConversationParams,
      AxiosResponse<IStopVoiceConversationResponse>
    >("/StopVoiceConversation", params);
    return response.data;
  }

  async getVoiceConversationStatus(params: IVoiceConversationStatusParams) {
    const response = await $axios.post<
      IVoiceConversationStatusParams,
      AxiosResponse<IVoiceConversationStatusResponse>
    >("/GetVoiceConversationStatus", params);
    return response.data;
  }
}

export const voiceChatService = new VoiceChatService();
